<div class="columns">
  <div class="column pagamento-cel-intro has-vertically-aligned-content">
    <table class="table is-narrow-desktop">
      <tbody>
        <tr>
          <th i18n="@@refPayment">Rif</th>
          <td>{{pagamento.id}}</td>
        </tr>
        <tr>
          <th i18n="@@paymentDate">Data</th>
          <td class="date-field">{{pagamento.data | date: 'longDate' }}</td>
        </tr>
        <tr class="is-hidden-tablet">
          <th i18n="@@endInsurance">Fine validità</th>
          <td class="date-field">{{fineValidita | date: 'longDate' }}</td>
        </tr>
        <tr>
          <th i18n="@@paymentBy">Metodo</th>
          <td>
            <ng-container [ngSwitch]="pagamento.tipo">
              <span *ngSwitchCase="1" i18n="@@bankTransfer">Bonifico</span>
              <span *ngSwitchCase="2">Bollettino postale</span>
              <span *ngSwitchCase="3" i18n="@@creditCard">Carta di credito</span>
              <span *ngSwitchCase="4" i18n="@@cash">Contanti</span>
              <span *ngSwitchCase="5">POS</span>
            </ng-container>
          </td>
        </tr>
        <tr *ngIf="pagamento.luogo">
          <th i18n="office">Ufficio</th>
          <td>{{pagamento.luogo}}</td>
        </tr>
        <tr *ngIf="pagamento.status == 1 && pagamento.bloccato">
          <th i18n="paymentPending">Pagamento in attesa</th>
          <td>&nbsp;</td>
        </tr>
        <tr *ngIf="(pagamento.status == 1 && !pagamento.bloccato) || pagamento.status == 2">
          <th i18n="paymentRefused">Pagamento fallito</th>
          <td><a class="button is-link" [routerLink]="['/area-utente', 'pagamento']" i18n="retrieve">Riprova</a></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div
    class="column pagamento-cel-enfasi is-one-third-mobile is-narrow has-text-centered has-vertically-aligned-content column-info-border-important">
    <p class='stat-val'>{{pagamento.numeroBeneficiari}}</p>
    <p class='stat-key' i18n="@@beneficiaries">beneficiari</p>
  </div>
  <div
    class="column pagamento-cel-enfasi is-one-third-mobile is-narrow has-text-centered has-vertically-aligned-content column-info-border-important">
    <p class='stat-val'>{{pagamento.importo | currency:'EUR'}}</p>
    <p class='stat-key' i18n="@@amountMinus">importo</p>
  </div>
  <div
    class="column pagamento-cel-enfasi is-one-third-mobile is-narrow has-text-centered has-vertically-aligned-content">
    <p class='stat-val'>
      <span *ngIf="pagamento.contributo; else noContributo"> {{pagamento.contributo | currency:'EUR'}}</span>
      <ng-template #noContributo>
        N/A
      </ng-template>
    </p>
    <p class='stat-key' i18n="@@contribution">Contributo</p>
  </div>
  <div class="column is-narrow has-vertically-aligned-content">
    <a class="button is-text" (click)="getRicevuta()" *ngIf="pagamento.status == 0">
      <span i18n="@@invoicePdf">Ricevuta</span><i class="fas fa-file-pdf fa-fw"></i>
    </a>
    <a class="button" (click)="expand(pagamento.id)" style="border: 0;">
      <span i18n="@@details">Dettagli</span><i class="fa fa-chevron-down fa-fw" [@toggleArrow]="state"></i>
    </a>
  </div>
</div>
<div *ngIf="beneficiari.length > 0" [@toggleAnimation]="state">
  <table class="table is-striped is-fullwidth">
    <thead>
      <tr>
        <th class="is-hidden-mobile">Id</th>
        <th i18n="@@name">Nome</th>
        <th i18n="@@cardOrChip" class="is-hidden-mobile">Tessera/Chip</th>
        <th i18n="@@birthDate" class="is-hidden-mobile">Data Nascita</th>
        <th i18n="@@startInsurance" class="is-hidden-mobile">Inizio validità</th>
        <th i18n="@@endInsurance" class="is-hidden-mobile">Fine validità</th>
        <th i18n="@@amount">Importo</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let beneficiario of beneficiari">
        <td class="is-hidden-mobile">
          {{beneficiario.id}}
        </td>
        <td>
          <ng-container [ngSwitch]="beneficiario.tipo">
            <span *ngSwitchCase="1"><i class="fas fa-user is-hidden-mobile fa-fw"></i>{{beneficiario.nome}}</span>
            <span *ngSwitchCase="2"><i class="fas fa-paw is-hidden-mobile fa-fw"></i>{{beneficiario.nome}}</span>
          </ng-container>
        </td>
        <td class="is-hidden-mobile">
          {{beneficiario.tesseraChip}}
        </td>
        <td class="is-hidden-mobile">
          <span *ngIf="beneficiario.natoIl ">{{beneficiario.natoIl | date}}</span>
        </td>
        <td class="is-hidden-mobile">
          {{inizioValidita | date}}
        </td>
        <td class="is-hidden-mobile">
          {{fineValidita | date}}
        </td>
        <td>
          {{beneficiario.importo | currency:'EUR' }}
        </td>
      </tr>
    </tbody>
  </table>
</div>